module.exports = __webpack_public_path__ + "static/img/copyIcon.f84865a8.svg";